import BankIcon from "../../../assets/images/BankIcon";
import BankIcon2 from "../../../assets/images/BankIcon2";
import BriefcaseIcon from "../../../assets/images/BriefcaseIcon";
import BriefcaseIconWhiteBG from "../../../assets/images/BriefcaseIconWhiteBG";
import ProfileIcon2 from "../../../assets/images/ProfileIcon2";
import ProfileIconWhiteBG from "../../../assets/images/ProfileIconWhiteBG";
import RoleIcon from "../../../assets/images/RoleIcon";
import RoleIcon2 from "../../../assets/images/RoleIcon2";
import StaffValidationIcon from "../../../assets/images/StaffValidationIcon";
import StaffValidationIcon2 from "../../../assets/images/StaffValidationIcon2";
import { StaffListConstants } from "../../../constants/constants";
import { STATUS } from "../../../store/slices/userDetailslice";
import { DynamicUserDetail } from "../../common/DynamicUserDeatil";
import LoaderPopupModel from "../../common/LoaderPopup";
import PersonalInformationDynamic from "../../common/PersonalInformationDynamic";
import Popup from "../../common/PopupComponent";
import { SideMenuStaffVerification } from "../../common/SideMenuStaffVerification";
import { Tab } from "../../common/StaffDetailscomponent";
import Loader from "../../common/styles/Loader";
import { UserProfileDetail } from "../../common/UserProfileDetail";
const actionTabs: Tab[] = [
  {
    label: "Personal",
    icon: ProfileIconWhiteBG,
    activeIcon: ProfileIcon2,
  },
  {
    label: "Education And Work",
    icon: BriefcaseIconWhiteBG,
    activeIcon: BriefcaseIcon,
  },
  {
    label: "Roles And Apps",
    icon: RoleIcon,
    activeIcon: RoleIcon2,
  },
  {
    label: "Bank Info",
    icon: BankIcon,
    activeIcon: BankIcon2,
  },
  {
    label: "Validation",
    icon: StaffValidationIcon,
    activeIcon: StaffValidationIcon2,
  },
];
export const getActionTabs = (ekycEnabled: boolean) => {
  if (ekycEnabled) {
    return actionTabs;
  } else {
    return actionTabs.filter((tab) => tab.label !== "Validation");
  }
};
export const StaffDetailAndroid = ({
  isUserDetailLoading,
  isUserEditLoading,
  editButtonName,
  activeTab,
  editMode,
  handleEditButton,
  handleSaveButton,
  handleCancelButton,
  handleAddMoreRolesButton,
  editPayloadJson,
  tabs,
  handleTabClick,
  setEditPayloadjson,
  setEditMode,
  key,
  isSaveButtonCLicked,
  setIsErrors,
  setIsSaveButtonClicked,
  errors,
  setShowSaveRolesButton,
  setShowSaveWorkButton,
  setShowSaveEducationButton,
  showSaveRolesButton,
  showSaveWorkButton,
  showSaveEducationButton,
  setEditModeForEducationalDetails,
  editModeForEducationalDetails,
  setEditModeForWorkDetails,
  editModeForWorkDetails,
  setErrors,
  showPopUp,
  closeModal,
  updateUserLoading,
  resendConsentSMS,
  popUpMsg,
  isApiSucessfull,
  setIsPhoneNumberAlreadyExistsInEditFLow,
  setSaveWithDeletedRoles,
  saveWithDeletedRoles,
  setSelectedSpecializationList,
  selectedSpecializationList,
  setCapturedFileImage,
  capturedFileImage,
  cameraError,
  isErrors,
  cameraErrorstatus,
  saveEditUserDetails,
  setShowPopUp,
  setIsApiSucesssful,
  userid,
  showCameraErrorMessage,
  setCapturedImage,
  capturedImage,
  cameraErrorInEditFLow,
  cameraErrorstatusInEditFLow,
}: any) => {
  return (
    <>
      {isUserDetailLoading ? (
        <div className="h-[600px] items-center justify-center bg-white">
          <Loader />
        </div>
      ) : (
        <>
          {isUserEditLoading && <LoaderPopupModel isOpen={isUserEditLoading} />}
          <div className="flex flex-col  rounded-xl border-t  pt-4 mt-4  ">
            <UserProfileDetail
              editButtonName={editButtonName}
              activeTab={activeTab}
              isEditMode={editMode}
              handleEditButton={handleEditButton}
              handleSaveButton={handleSaveButton}
              handleCancelButton={handleCancelButton}
              handleAddMoreRolesButton={handleAddMoreRolesButton}
              jsonObjData={editPayloadJson}
              isAndroid={true}
              setCapturedFileImage={setCapturedFileImage}
              capturedFileImage={capturedFileImage}
              cameraError={cameraError}
              cameraErrorstatus={cameraErrorstatus}
              saveEditUserDetails={saveEditUserDetails}
              editPayloadJson={editPayloadJson}
              isErrors={isErrors}
              isErrorNotPresent={true}
              setEditMode={setEditMode}
  setIsErrors={setIsErrors}
  setSaveWithDeletedRoles={setSaveWithDeletedRoles}
  setIsSaveButtonClicked={setIsSaveButtonClicked}
  setShowSaveRolesButton={setShowSaveRolesButton}
  setShowPopUp={setShowPopUp}
  setIsApiSucesssful={setIsApiSucesssful}
  userid={userid}
  showCameraErrorMessage={showCameraErrorMessage}
  setCapturedImage={setCapturedImage}
capturedImage={capturedImage}   
cameraErrorInEditFLow={cameraErrorInEditFLow}  
  cameraErrorstatusInEditFLow={cameraErrorstatusInEditFLow}
            />

            <div className="flex flex-wrap justify-between py-4  p-4 ">
              <div className="flex  gap-3 flex-wrap">
                {getActionTabs(editPayloadJson?.isKycEnabled).map(
                  (tab: any, index: number) => (
                    <div
                      key={index}
                      data-testId={`tab ${index}`}
                      className={`flex items-center px-4 py-2 rounded-full cursor-pointer transition-all duration-200
        ${
          activeTab === index
            ? "bg-primary   text-white font-bold text-xs border border-primary"
            : "bg-white text-gray-700 hover:bg-gray-200 text-xs font-normal border border-gray500"
        }`}
                      onClick={() => handleTabClick(index)}
                    >
                      {activeTab === index ? (
                        <tab.activeIcon
                          height={"16px"}
                          width={"16px"}
                          fillColor="#FFFFFF"
                        />
                      ) : (
                        <tab.icon height={"16px"} width={"16px"} />
                      )}
                      <span className="pl-2 whitespace-nowrap font-nunito ">
                        {tab.label}
                      </span>
                    </div>
                  )
                )}
              </div>
            </div>
            {activeTab === 4 && (
              <div className="bg-white">
                <SideMenuStaffVerification />
              </div>
            )}
            {!editMode ? (
              <div className=" p-3 bg-white mx-4 rounded-lg">
                {editPayloadJson && (
                  <DynamicUserDetail
                    key={key}
                    jsonObj={editPayloadJson?.formSegments}
                    setEditPayloadjson={setEditPayloadjson}
                    setEditMode={setEditMode}
                    order={activeTab}
                    jsonForEditData={editPayloadJson}
                    isEditMode={editMode}
                    handleSaveButton={handleSaveButton}
                    handleCancelButton={handleCancelButton}
                    isSaveButtonCLicked={isSaveButtonCLicked}
                    errors={errors}
                    setShowSaveRolesButton={setShowSaveRolesButton}
                    setShowSaveWorkButton={setShowSaveWorkButton}
                    setShowSaveEducationButton={setShowSaveEducationButton}
                    showSaveRolesButton={showSaveRolesButton}
                    showSaveWorkButton={showSaveWorkButton}
                    showSaveEducationButton={showSaveEducationButton}
                    setEditModeForEducationalDetails={
                      setEditModeForEducationalDetails
                    }
                    editModeForEducationalDetails={
                      editModeForEducationalDetails
                    }
                    setEditModeForWorkDetails={setEditModeForWorkDetails}
                    editModeForWorkDetails={editModeForWorkDetails}
                    setIsSaveButtonClicked={setIsSaveButtonClicked}
                    setErrors={setErrors}
                    isApiSucessfull={isApiSucessfull}
                    setSaveWithDeletedRoles={setSaveWithDeletedRoles}
                    saveWithDeletedRoles={saveWithDeletedRoles}
                    setIsErrors={setIsErrors}
                    setSelectedSpecializationList={
                      setSelectedSpecializationList
                    }
                    selectedSpecializationList={selectedSpecializationList}
                  />
                )}
              </div>
            ) : (
              <div className="bg-white">
                <PersonalInformationDynamic
                  jsonobj={editPayloadJson?.formSegments}
                  order={activeTab}
                  isEditMode={editMode}
                  setEditPayloadjson={setEditPayloadjson}
                  isSaveButtonCLicked={isSaveButtonCLicked}
                  setIsErrors={setIsErrors}
                  setIsSaveButtonClicked={setIsSaveButtonClicked}
                  errors={errors}
                  setErrors={setErrors}
                  setIsPhoneNumberAlreadyExistsInEditFLow={
                    setIsPhoneNumberAlreadyExistsInEditFLow
                  }
                />
              </div>
            )}
            {showPopUp && (
              <Popup
                popUpTitle={popUpMsg.title}
                popUpMsg={popUpMsg.message}
                buttonText={StaffListConstants.Okay}
                isOpen={showPopUp}
                onClose={closeModal}
                isSucessMessage={
                  updateUserLoading === STATUS.SUCCESS ||
                  resendConsentSMS?.smsSent === true
                    ? true
                    : false
                }
              />
            )}
          </div>
        </>
      )}
    </>
  );
};
